import React from 'react';

import {StyledGrid} from 'presentation/components';
import {BeneficiaryCard} from 'presentation/pages/others/selection-flow/components';
import {RenderBeneficiariesProps} from './types';
import {useShareAccessFeatureFlag} from 'presentation/pages/private/hooks/useShareAccessFeatureFlag';

export const RenderBeneficiaries = ({
	list,
	isCompareSelectedBeneficiary,
	handleSelectBeneficiary,
	hasOnlyCanceled,
}: RenderBeneficiariesProps) => {
	const {isEnabled: isShareAccessEnabled} = useShareAccessFeatureFlag();

	return list.map(beneficiary => (
		<StyledGrid.Item key={beneficiary.cdUsuarioC} sm={12} md={12} lg={6} xl={4} display="flex">
			<BeneficiaryCard
				selected={isCompareSelectedBeneficiary(beneficiary)}
				onSelect={handleSelectBeneficiary}
				beneficiary={beneficiary}
				allCancelled={hasOnlyCanceled}
				blocked={beneficiary.flPermitido === 'N' && isShareAccessEnabled}
			/>
		</StyledGrid.Item>
	));
};
